"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressModalConfig = void 0;
const React = __importStar(require("react"));
const useAddressModalConfigService_hook_1 = require("./useAddressModalConfigService.hook");
const features_1 = require("../../features");
const useAddressModalConfig = (API) => {
    const [regularStatesList, setRegularStatesList] = React.useState([]);
    const [militaryStatesList, setMilitaryStatesList] = React.useState([]);
    const { getStatesCall, statesData } = (0, useAddressModalConfigService_hook_1.useStatesService)();
    React.useEffect(() => {
        getStatesCall(API);
    }, []);
    React.useEffect(() => {
        if (statesData) {
            const { regularStates, militaryStates } = (0, features_1.splitStates)(statesData);
            setRegularStatesList(regularStates);
            setMilitaryStatesList(militaryStates);
        }
    }, [statesData]);
    return {
        regularStates: regularStatesList,
        militaryStates: militaryStatesList,
    };
};
exports.useAddressModalConfig = useAddressModalConfig;
//# sourceMappingURL=useAddressModalConfig.hook.js.map